import { makeStyles } from '@material-ui/core';
import HeadlessTippy from '@tippyjs/react/headless';
import React, { useEffect, useMemo, useState } from 'react';
import { matchPath, useLocation } from 'react-router-dom';
import { useLocalStorage } from 'src/hooks/use-local-storage';
import { sticky } from 'tippy.js';
import { useReleaseHintReferences } from './config';
import Popper from './popper';
import { useReleaseHintReferenceDoms } from './release-hint-provider';
import { getReleaseHintReferenceId } from './use-register-release-hint-reference';

const useStyles = makeStyles(
  () => ({
    cover: {
      position: 'fixed',
      top: 0,
      bottom: 0,
      right: 0,
      left: 0,
      zIndex: 999,
    },
    rightList: {
      zIndex: 9,
    },
    referenceParent: {
      transform: 'none !important',
    },
  }),
  { name: 'ReleaseHint' }
);
function ReleaseHint() {
  const classes = useStyles();
  const location = useLocation();
  const releaseHintReferenceDoms = useReleaseHintReferenceDoms();
  const [currentHintIndex, setCurrentHintIndex] = useState(0);
  const [readReleaseHintId, setReadReleaseHintId] = useLocalStorage('readReleaseHintId');

  const releaseHintConfigs = useReleaseHintReferences();
  const isAtReleaseHintUrl = useMemo(() => matchPath(location.pathname, releaseHintConfigs.url), [
    location.pathname,
    releaseHintConfigs.url,
  ]);
  const isReleaseHintRead = readReleaseHintId === releaseHintConfigs.releaseDate;

  const hintConfig = useMemo(() => releaseHintConfigs.hints[currentHintIndex], [
    currentHintIndex,
    releaseHintConfigs.hints,
  ]);

  const releaseHintReference = useMemo(() => {
    const currentRenderedHintReferenceId = getReleaseHintReferenceId(
      releaseHintConfigs.releaseDate,
      hintConfig.name
    );
    return releaseHintReferenceDoms[currentRenderedHintReferenceId];
  }, [hintConfig.name, releaseHintConfigs.releaseDate, releaseHintReferenceDoms]);

  const isLastHint = currentHintIndex === releaseHintConfigs.hints.length - 1;

  const handleRead = () => {
    if (!isLastHint) {
      setCurrentHintIndex(currentHintIndex + 1);
    } else {
      setReadReleaseHintId(releaseHintConfigs.releaseDate);
    }
  };

  const renderReleaseHintContent = (attrs) => (
    <Popper hintConfig={hintConfig} attrs={attrs} handleRead={handleRead} isLastHint={isLastHint} />
  );

  const renderCover = () => <div className={classes.cover} id="for-release-hint-cover"></div>;

  useEffect(() => {
    if (isAtReleaseHintUrl && !isReleaseHintRead) {
      if (document.getElementById('for-release-hint-cover')) {
        document
          .getElementById('for-release-hint-cover')
          .parentNode.classList.add(classes.referenceParent);
      }
      document.querySelector('#for-release-hint-right-side').classList.add(classes.rightList);
    } else {
      document
        .getElementById('for-release-hint-cover')
        ?.parentNode?.classList.remove(classes.referenceParent);
      document.querySelector('#for-release-hint-right-side').classList.remove(classes.rightList);
    }
  }, [
    classes.coverParent,
    classes.referenceParent,
    classes.rightList,
    classes.topBar,
    isAtReleaseHintUrl,
    isReleaseHintRead,
    releaseHintReference,
  ]);

  return (
    isAtReleaseHintUrl &&
    !isReleaseHintRead && (
      <div>
        <HeadlessTippy
          visible={!!releaseHintReference}
          render={(attrs) => renderCover(attrs)}
          reference={releaseHintReference}
          sticky="reference"
          plugins={[sticky]}
          interactive
        />
        <HeadlessTippy
          visible={!!releaseHintReference}
          render={(attrs) => renderReleaseHintContent(attrs)}
          reference={releaseHintReference}
          sticky="reference"
          plugins={[sticky]}
          interactive
        />
      </div>
    )
  );
}

ReleaseHint.propTypes = {};

export default ReleaseHint;
